import { biLogger } from '../biLogger';
import { placement } from '../constants';
import { selectBiData } from '../selectors';
import { BiEventLogger, ChatbotNotificationsBiData } from '../types';
import { getRuntimeDataForBi } from '../utils';

export const logChatbotNotifications: BiEventLogger<ChatbotNotificationsBiData> = async (
  state,
  { counterValue },
) => {
  const biData = selectBiData(state);
  const { sessionId, metaSiteId, chatbotView, contextBi } = await getRuntimeDataForBi(state);

  biLogger.chatbotNotifications({
    counter_value: counterValue,
    chatbot_view: chatbotView,
    current_presented_state: biData.currentPresentedState,
    previous_presented_state: biData.previousPresentedState,
    last_conversation_id: biData.conversationId,
    last_chatbot_node_id: biData.nodeId,
    last_user_intent_id: biData.intentId,
    orig_page_name: biData.origPageName,
    orig_platform: biData.origPlatform,
    context_area: contextBi?.context_area,
    context_domain: contextBi?.context_domain,
    context_iframeurllist: contextBi?.context_iframeurllist,
    context_msid: contextBi?.context_msid,
    context_page_numlevels: contextBi?.context_page_numlevels,
    context_page_queryparams: contextBi?.context_page_queryparams,
    context_page_toplevelroute: contextBi?.context_page_toplevelroute,
    context_page_urlchunks: contextBi?.context_page_urlchunks,
    context_parenturl: contextBi?.context_parenturl,
    context_platform: contextBi?.context_platform,
    context_uuid: contextBi?.context_uuid,
    user_experience: contextBi?.user_experience,
    current_page_name: document.title,
    msid: metaSiteId,
    placement,
    session_id: sessionId,
    last_user_intent: undefined,
    last_chatbot_node_name: undefined,
    is_chatbot_solution_click: undefined,
    referral_info: undefined,
  });
};
